
import React, { useEffect, useState } from 'react'
import PageTitleBanner from '../../Components/Reusable/PageTitleBanner'
import ApiService from '../../Services/ApiService';
import Image from "../../Components/Reusable/Image";
import { PngImages, SvgImages } from '../../Utils/LocalImages';
import { Link } from 'react-router-dom';
import imageone from '../../assets/images/png/mainimageblog.png'
import generatePaginationFooter from '../../Components/Reusable/CustomPagination';
import RoutesPath from '../../Utils/RoutesPath';
import CustomDropDownReward from '../../Components/Reusable/CustomDropDownReward';
import { handleApiErrors } from '../../Utils/Utils';
import ApiConstants from "../../Utils/ApiConstant";
import dayjs from 'dayjs';

const Blog = () => {
  const [blogCategories, setBlogCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [blogData, setBlogData] = useState([]);
  const [authors, setAuthors] = useState([]);
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [offset, setOffset] = useState(0);
  const [limit] = useState(9);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [activecategory, setActivecategory] = useState('');

  useEffect(() => {
    getAllAuthers();
    getBlogdata();
  }, []);

  useEffect(() => {
    if (selectedCategoryId !== null) {
      getBlogdata(selectedCategoryId, offset, limit);
    }
  }, [selectedCategoryId, offset, limit]);

  const getBlogdata = async (categoryId, offset, limit) => {
    try {
      const response = await ApiService.getBlogdata(categoryId, offset, limit);
      setBlogCategories(response.data.blogCategoryData ?? []);
      setBlogData(response.data.BlogData ?? []);
      if (!selectedCategoryId && response.data.blogCategoryData.length > 0) {
        setSelectedCategoryId(response.data.blogCategoryData[0].blog_Category_id); // Automatically select the first category
      }
      setAvailableDataCount(response.availableDataCount);
    } catch (error) {
      handleApiErrors(error);
    }
  };
  const handleCategoryClick = (categoryId, categoryName) => {
    setSelectedCategoryId(categoryId);
    setActivecategory(categoryName)
    setSelectedIndex(-1);
    setOffset(0) // Reset the selected question index when changing category
  };
  const handleDropdownChange = (selectedOption) => {
    const selectedCategory = blogCategories.find(category => category.categoryName === selectedOption.value);
    if (selectedCategory) {
      setSelectedCategoryId(selectedCategory.blog_Category_id);
      setActivecategory(selectedCategory.categoryName);
    }
  };
  const getAllAuthers = async () => {
    try {
      const response = await ApiService.getAllAuthers();
      setAuthors(response.authorData);
    } catch (error) {
      handleApiErrors(error);
    }
  };
  const findAuthorNameById = (authorId) => {
    const author = authors.find(author => author.author_id === authorId);
    return author ? author.name : 'Unknown Author';
  };
  return (
    <div className="d-flex flex-column mb-auto Blogcardspage">
      <PageTitleBanner PageTitle={"Blog"}
        breadCrumpPageTitle={'Blog'} />
      <div className="text-content-page-container d-flex flex-column align-items-center ">
        <div className="w-100 categories-dropdown mt-4 d-block d-md-none">
          <CustomDropDownReward
            labelTitle=""
            id="category"
            name="category"
            placeholder="Select Category"
            options={blogCategories?.map((category) => ({ value: category.categoryName, label: category.categoryName }))}
            // defaultOption={{ value: activecategory, label: activecategory ? activecategory : blogCategories[0]?.categoryName }}
            defaultOption={{
              value: activecategory || blogCategories[0]?.categoryName,
              label: activecategory || blogCategories[0]?.categoryName
            }}
            additionalclass={"Dropdownstylingblogs"}
            onChange={(selectedOption) => handleDropdownChange(selectedOption)}
          />
        </div>
        <div className="sub-tabs d-flex gap-4 align-items-center mb-3 cursor-pointer ">
          {blogCategories.map((category, index) => (
            <h2
              key={index}
              className={`Sub-Heading text-uppercase mb-0 ${selectedCategoryId === category.blog_Category_id ? "category-tab-selected" : "category-tab"}`}
              onClick={() => handleCategoryClick(category.blog_Category_id, category.categoryName)}>
              {category.categoryName}
            </h2>
          ))}
        </div>
        <div className='container' >
          {
            blogData.length > 0 ? (
              <div className="row BlogMobileresponsive ">
                {blogData.map((card, cardIndex) => (
                  <div className='col-md-4 d-flex justify-content-center mb-4' key={cardIndex}>
                    <div className="card  BlogDetailcards" >
                      <div className='blogcardimagesize'>
                        <Image src={card.mainImage ? ApiConstants.FILE_FETCH_URL + card.mainImage : PngImages.blogdetailimage} className="card-img-top Blogcardimage" alt="..." />
                      </div>
                      <div className="card-body d-flex flex-column gap-3" style={{ overflow: 'hidden' }}>
                        <div className='d-flex gap-3'>
                          <div className='d-flex gap-2 align-items-center'>
                            <Image src={PngImages.bloguser} />
                            <h3 className='small-text fw-400 mb-0 author'>{findAuthorNameById(card.author_id)}</h3>
                          </div>
                          <div className='d-flex gap-2 align-items-center'>
                            <Image src={PngImages.blogcalender} />
                            <h3 className='small-text fw-400 mb-0 author'>{dayjs(card.date).format("DD, MM, YYYY")}</h3>
                          </div>
                        </div>
                        <div style={{ height: '105px' }}>
                          <h5 className="card-title large-text fw-600 darkBlueColor Blogtexting mb-1 text-capitalize">{card.title}</h5>
                          <p className="card-text medium-text fw-400 Blogtexting mb-0" >{card.briefIntro}</p>
                        </div>
                        <div className='d-flex justify-content-end'>
                          <div className='d-flex align-items-center gap-2'>
                            <Link to={`${RoutesPath.blogdetails}/${card.blog_id}`}><h3 className='medium-text fw-500 mb-0 black'>Read more</h3></Link>
                            <Image src={SvgImages.blogrightarrow} style={{ marginTop: 2 }} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
                }
                {generatePaginationFooter(
                  availableDataCount,
                  limit,
                  offset,
                  setOffset
                )}
              </div>
            ) :
              <div className=" text-center">
                <div className="d-flex justify-content-center">
                  <Image src={PngImages.no_record} className="img-fluid" />
                </div>
                <p className="no-records-text sub-large-text-one fw-700 mb-0">No Blogs Found...</p>
              </div>
          }
        </div>
      </div>
    </div>
  )
}
export default Blog
